import React, { useState } from 'react';
import FeedPhoto from '../shared/FeedPhoto';
import PhotoViewer from '../shared/PhotoViewer';
import { motion, AnimatePresence } from 'framer-motion';

const WallModal = ({ showWallModal, wallData, wallLoading, wallMessage, setWallMessage, onClose, onSendMessage, onReactToMessage, user }) => {
  const [viewerSrc, setViewerSrc] = useState(null);
  if (!showWallModal) return null;

  return (
    <AnimatePresence>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'flex-end' }}
        onClick={onClose}>
        <motion.div initial={{ y: '100%' }} animate={{ y: 0 }} exit={{ y: '100%' }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          style={{ width: '100%', maxHeight: '85vh', background: 'white', borderRadius: '20px 20px 0 0', overflow: 'hidden' }}
          onClick={(e) => e.stopPropagation()}>

          {/* Header */}
          <div style={{
            padding: '16px 20px',
            background: showWallModal.type === 'birthday' ? 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)'
              : showWallModal.type === 'announcement' ? 'linear-gradient(135deg, #5DBFAD 0%, #7DD3C0 100%)'
              : 'linear-gradient(135deg, #10B981 0%, #34D399 100%)',
            color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'space-between'
          }}>
            <div>
              <div style={{ fontSize: 18, fontWeight: 700 }}>
                {showWallModal.type === 'birthday' && 'Birthday Wall'}
                {showWallModal.type === 'announcement' && 'Announcement'}
                {showWallModal.type === 'event_memory' && 'Event Memories'}
              </div>
              <div style={{ fontSize: 13, opacity: 0.9, marginTop: 2 }}>
                {showWallModal.type === 'birthday' && wallData?.user?.username
                  ? `Wish ${wallData.user.username} a happy birthday!`
                  : showWallModal.type === 'announcement' && wallData?.announcement?.title
                  ? wallData.announcement.title
                  : showWallModal.type === 'event_memory' && wallData?.memory?.event_title
                  ? wallData.memory.event_title : 'Loading...'}
              </div>
            </div>
            <button onClick={onClose} data-testid="close-wall-modal"
              style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white', fontSize: 20 }}>
              x
            </button>
          </div>

          {/* Content */}
          <div style={{ maxHeight: 'calc(85vh - 140px)', overflowY: 'auto', padding: '16px 20px' }}>
            {!wallLoading && wallData?.unavailable ? (
              <div data-testid="announcement-unavailable" style={{ textAlign: 'center', padding: 40, color: '#6B7280' }}>This announcement is no longer available</div>
            ) : wallLoading ? (
              <div style={{ textAlign: 'center', padding: 40 }}>
                <div style={{ color: '#6B7280' }}>Loading...</div>
              </div>
            ) : showWallModal.type === 'birthday' && wallData ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20, padding: 16, background: '#FEF3C7', borderRadius: 12 }}>
                  <div style={{ width: 60, height: 60, borderRadius: '50%', background: '#F59E0B', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: 24, fontWeight: 700, overflow: 'hidden' }}>
                    {wallData.user?.profile_photo
                      ? <img src={wallData.user.profile_photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      : wallData.user?.username?.[0]?.toUpperCase() || '?'}
                  </div>
                  <div>
                    <div style={{ fontSize: 18, fontWeight: 700, color: '#92400E' }}>{wallData.user?.username}</div>
                    <div style={{ fontSize: 14, color: '#B45309' }}>Wish them a happy birthday!</div>
                  </div>
                </div>
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 12 }}>Birthday Wishes ({wallData.messages?.length || 0})</div>
                  {wallData.messages?.length > 0 ? wallData.messages.map((msg) => (
                    <div key={msg.id} style={{ padding: 12, background: '#FFFBEB', borderRadius: 12, marginBottom: 10, border: '1px solid #FEF3C7' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                        <span style={{ fontWeight: 600, fontSize: 13, color: '#92400E' }}>{msg.username}</span>
                        <span style={{ fontSize: 11, color: '#B45309' }}>{new Date(msg.created_at).toLocaleDateString()}</span>
                      </div>
                      <div style={{ fontSize: 14, color: '#78350F' }}>{msg.content}</div>
                      {msg.image_url && <FeedPhoto src={msg.image_url} alt={`Photo from ${msg.username || 'a colleague'}`} style={{ marginTop: 8, borderRadius: 8 }} />}
                      <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
                        {['&#127881;', '&#10084;&#65039;', '&#127874;', '&#129395;'].map(emoji => (
                          <button key={emoji} onClick={() => onReactToMessage(msg.id, emoji)}
                            style={{ padding: '4px 8px', background: '#F3F4F6', border: '1px solid #E5E7EB', borderRadius: 20, cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', gap: 4 }}
                            dangerouslySetInnerHTML={{ __html: `${emoji} ${msg.reactions?.[emoji]?.length || ''}` }} />
                        ))}
                      </div>
                    </div>
                  )) : (
                    <div style={{ textAlign: 'center', padding: 20, color: '#B45309' }}>Be the first to send a birthday wish!</div>
                  )}
                </div>
              </>
            ) : showWallModal.type === 'announcement' && wallData ? (
              <>
                <div style={{ marginBottom: 20 }}>
                  {wallData.announcement?.image_url && <FeedPhoto src={wallData.announcement.image_url} alt={wallData.announcement.title || 'Announcement image'} testId="announcement-photo" style={{ borderRadius: 12, marginBottom: 12 }} />}
                  <div style={{ fontSize: 15, color: '#374151', lineHeight: 1.6 }}>{wallData.announcement?.description}</div>
                  <div style={{ fontSize: 12, color: '#6B7280', marginTop: 8 }}>Posted by {wallData.announcement?.created_by_name} - {new Date(wallData.announcement?.created_at).toLocaleDateString()}</div>
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 12 }}>Comments ({wallData.messages?.length || 0})</div>
                  {wallData.messages?.map((msg) => (
                    <div key={msg.id} style={{ padding: 12, background: '#F5F3FF', borderRadius: 12, marginBottom: 10, border: '1px solid #EDE9FE' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                        <span style={{ fontWeight: 600, fontSize: 13, color: '#5B21B6' }}>{msg.username}</span>
                        <span style={{ fontSize: 11, color: '#5DBFAD' }}>{new Date(msg.created_at).toLocaleDateString()}</span>
                      </div>
                      <div style={{ fontSize: 14, color: '#4C1D95' }}>{msg.content}</div>
                    </div>
                  ))}
                </div>
              </>
            ) : showWallModal.type === 'event_memory' && wallData ? (
              <>
                <div style={{ padding: 16, background: '#ECFDF5', borderRadius: 12, marginBottom: 16 }}>
                  <div style={{ fontSize: 16, fontWeight: 700, color: '#065F46' }}>{wallData.memory?.event_title}</div>
                  <div style={{ fontSize: 13, color: '#047857', marginTop: 4 }}>{new Date(wallData.memory?.event_date).toLocaleDateString()}</div>
                </div>
                {wallData.memory?.images?.length > 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 12 }}>Photos ({wallData.memory.images.length})</div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
                      {wallData.memory.images.map((img, idx) => (
                        <button key={idx} type="button" onClick={() => setViewerSrc(img)} aria-label={`Open photo ${idx + 1}`} data-testid={`memory-photo-${idx}`}
                          style={{ padding: 0, border: 'none', background: '#F3F4F6', borderRadius: 8, overflow: 'hidden', cursor: 'zoom-in' }}>
                          <img src={img} alt={`Event photo ${idx + 1}`} loading="lazy" style={{ display: 'block', width: '100%', aspectRatio: '1', objectFit: 'cover' }} />
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 12 }}>Messages ({wallData.messages?.length || 0})</div>
                  {wallData.messages?.map((msg) => (
                    <div key={msg.id} style={{ padding: 12, background: '#F0FDF4', borderRadius: 12, marginBottom: 10, border: '1px solid #BBF7D0' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                        <span style={{ fontWeight: 600, fontSize: 13, color: '#166534' }}>{msg.username}</span>
                      </div>
                      <div style={{ fontSize: 14, color: '#15803D' }}>{msg.content}</div>
                      {msg.image_url && <FeedPhoto src={msg.image_url} alt={`Photo from ${msg.username || 'a colleague'}`} style={{ marginTop: 8, borderRadius: 8 }} />}
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div style={{ textAlign: 'center', padding: 40, color: '#6B7280' }}>Unable to load content</div>
            )}
          </div>

          {/* Message Input */}
          {(showWallModal.type === 'birthday' || showWallModal.type === 'announcement') && !wallData?.unavailable && (
            <div style={{ padding: '12px 20px', borderTop: '1px solid #E5E7EB', background: '#F9FAFB', display: 'flex', gap: 10 }}>
              <input type="text" value={wallMessage} onChange={(e) => setWallMessage(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && onSendMessage()}
                placeholder={showWallModal.type === 'birthday' ? 'Send a birthday wish...' : 'Add a comment...'}
                data-testid="wall-message-input"
                style={{ flex: 1, padding: '12px 16px', border: '2px solid #E5E7EB', borderRadius: 24, fontSize: 14, outline: 'none' }} />
              <button onClick={onSendMessage} disabled={!wallMessage.trim()} data-testid="wall-send-btn"
                style={{
                  padding: '12px 20px',
                  background: wallMessage.trim()
                    ? showWallModal.type === 'birthday' ? 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)' : 'linear-gradient(135deg, #5DBFAD 0%, #7DD3C0 100%)'
                    : '#E5E7EB',
                  color: wallMessage.trim() ? 'white' : '#9CA3AF',
                  border: 'none', borderRadius: 24, fontWeight: 600,
                  cursor: wallMessage.trim() ? 'pointer' : 'not-allowed'
                }}>
                Send
              </button>
            </div>
          )}
        </motion.div>
      </motion.div>
      {viewerSrc && <PhotoViewer src={viewerSrc} alt="Event photo" onClose={() => setViewerSrc(null)} />}
    </AnimatePresence>
  );
};

export default WallModal;
